<template>
  <div
    class="kk-rightpanel__sub"
    :class="{
      'kk-rightpanel__sub-hidden': false,
    }"
  >
    <Tools />
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import Tools from "./Tools/tools.vue";
import { SubNavigations } from "../../../utils/constants";
SubNavigations;
export default {
  components: {
    Tools,
  },
  data() {
    return {
      SubNavigations: SubNavigations,
    };
  },
  computed: {},
  mounted() {},
  beforeUnmount() {},
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";
.kk-rightpanel {
  &__sub {
    flex-grow: 1;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #fff;
    opacity: 1;
    box-shadow: -3px 0 6px -2px rgba(0, 0, 0, 0.2);
  }
}
</style>
